import dayjs from 'dayjs'
import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { DEFAULT_FORM_VALUES } from '../share/Constant'
import { formatToDate } from '../utils/TimeUtility'

// ============================================================================
// PRIVATE SESSION（私教课程）相关 Atoms
// ============================================================================

const createPrivateSessionState = function () {
  // 私教课程表单数据
  const privateSessionFormAtom = atom(DEFAULT_FORM_VALUES)

  // 私教课程时间段选项（持久化存储）
  const timeSlotOptionsAtom = atomWithStorage('privateSessionTimeSlotOptions', {
    halfhour: false,
    startHour: 8,
    endHour: 21,
    sessionDuration: 60,
  })

  const privateSessionTemplateAtom = atomWithStorage('privateSessionTemplateAtom', { default: DEFAULT_FORM_VALUES })

  // 私教课程表单验证错误
  const privateSessionFormErrorAtom = atom({
    sport: '',
    skiResort: '',
    price: '',
    registrationDeadline: '',
    sessionDuration: '',
  })

  // 私教课程变更状态（创建、更新、删除的会话列表）
  const sessionsChangesAtom = atom({
    isChanged: false,
    sessionsToCreate: [],
    sessionsToUpdate: [],
    sessionsToDelete: [],
    openTimeSlots: [],
  })

  // 私教课程统一导出对象
  return {
    template: privateSessionTemplateAtom,
    form: privateSessionFormAtom,
    formError: privateSessionFormErrorAtom,
    timeSlotOptions: timeSlotOptionsAtom,
    timeSlots: atom([]),
    submit: atom(false),
    date: atom(formatToDate(dayjs())),
    sessionsChanges: sessionsChangesAtom,
    dialog: atom(false),
  }
}

const privateSessionStateAtom = createPrivateSessionState()

export const privateSessionCreateStateAtom = {
  form: privateSessionStateAtom.form,
  formError: privateSessionStateAtom.formError,
  timeSlotOptions: privateSessionStateAtom.timeSlotOptions,
  sessionsChanges: privateSessionStateAtom.sessionsChanges,
  atom: privateSessionStateAtom,
}

export default privateSessionStateAtom
export const privateSessionTemplateAtom = privateSessionStateAtom.template
export const privateSessionFormAtom = privateSessionStateAtom.form
export const privateSessionFormErrorAtom = privateSessionStateAtom.formError
export const privateSessionTimeSlotOptionsAtom = privateSessionStateAtom.timeSlotOptions
export const privateSessionTimeSlotsAtom = privateSessionStateAtom.timeSlots
export const privateSessionSubmitAtom = privateSessionStateAtom.submit
export const privateSessionDateAtom = privateSessionStateAtom.date
export const privateSessionSessionsChangesAtom = privateSessionStateAtom.sessionsChanges
export const privateSessionDialogAtom = privateSessionStateAtom.dialog
